import axios from 'axios'
import {
	ElMessage
} from 'element-plus'
import {
	reset,
	getPathName,
	getFilterUrl,
	getParentPathName,
	globalCacheDeleteNoPermissionApi
} from '@/utils/common'
import router from '@/router'
import defaultSettings from '@/settings'
import useUserStore from '@/store/modules/user'

const request = axios.create({
	// 注意！！ 这里是全局统一加上了 '/api' 前缀，也就是说所有接口都会加上'/api'前缀在，页面里面写接口的时候就不要加 '/api'了，否则会出现2个'/api'，类似 '/api/api/user'这样的报错，切记！！！
	baseURL: defaultSettings.systemLinkApi,
	// timeout: 60000,
	// withCredentials: true
})

let configObj = {}
// request 拦截器
// 可以自请求发送前对请求做一些处理
// 比如统一加token，对请求参数统一加密
request.interceptors.request.use(config => {
	// console.log(config, 'config')
	config.metadata = {
		startTime: Date.now()
	};
	config.timeout = config.url === 'home/search/checkSearch' ? 60000 : 15000;

	configObj = config
	const routeData = router.currentRoute.value
	const path = routeData.path
	const query = routeData.query
	console.log(configObj, routeData, path, query, 'configObjconfigObj')

	if (config.url === 'sys/file/upload/file' || config.url === 'sys/file/upload/file/service/station') {
		config.headers['Content-Type'] = 'multipart/form-data'
	} else {
		config.headers['Content-Type'] = 'application/json;charset=utf-8'
	}
	if (localStorage.getItem('token')) {
		config.headers['token'] = localStorage.getItem('token')
	}

	// 20251126 新增顶号后 加载最新的用户
	if (localStorage.getItem('userInfo') && JSON.stringify(useUserStore().userInfo) !== '{}') {
		const userInfo = JSON.parse(localStorage.getItem('userInfo'))
		if (userInfo.id !== useUserStore().userInfo.id) {
			useUserStore().userInfo = userInfo
		}
	}
	
	// 20260423 新增根据菜单查对应权限功能
	let filterUrl = ''
	if (query.pageType || query.type || query.params || query.id || query.templateId) {
		// 特殊页面 获取父级菜单
		filterUrl = getFilterUrl(path, query.pageType, query.type, query.params ? JSON.parse(query.params).path : '', query.id)
		console.log(filterUrl, 'filterUrl')
	}
	
	// 子级查对应的父级菜单
	const parUrl = getParentPathName(path.replace('/', ''))
	// 当前菜单路由
	const currentUrl = getPathName()
	const filterUrlPar = parUrl || currentUrl

	// 新增父级菜单
	config.headers['filter-url'] = filterUrl || (filterUrlPar ? '/' + filterUrlPar : '')

	return config
}, error => {
	return Promise.reject(error)
})

let num = 0


// response 拦截器
// 可以在接口响应后统一处理结果
request.interceptors.response.use(
	response => {
		let res = response.data
		let responseType = response.config.responseType
		// 如果是返回的文件
		if (responseType === 'blob' || responseType === 'arraybuffer') {
			return response
		}

		// 兼容服务端返回的字符串数据
		// if (typeof res === 'string') {
		// 	res = res ? JSON.parse(res) : res
		// }

		if (response.headers['token']) {
			let token = response.headers['token'] || ''
			localStorage.setItem('token', token)
		}
		// console.log(response, response.headers, 11112)
		// if (configObj.url.includes('sys/sysuser/order/downLoad')) {
		// 	var blob = new Blob([res], {
		// 		type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
		// 	});
		// 	let downloadElement = document.createElement('a');
		// 	let href = window.URL.createObjectURL(blob); //创建下载的链接
		// 	downloadElement.href = href;
		// 	// decodeURI 解决中文乱码问题 与后端配合解码
		// 	if (response.headers['content-disposition']) {
		// 		let str = response.headers['content-disposition'].split('.')[0]
		// 		downloadElement.download = !isNaN(str) ? response.headers['content-disposition'] : decodeURI(
		// 			response.headers['content-disposition']); //下载后文件名
		// 		document.body.appendChild(downloadElement);
		// 		downloadElement.click(); //点击下载
		// 		document.body.removeChild(downloadElement); //下载完成移除元素
		// 		window.URL.revokeObjectURL(href); //释放掉blob对象
		// 		return res
		// 	} else {
		// 		console.log(response, 'response')
		// 		return Promise.reject('未知异常，请联系管理员')
		// 	}
		// } else {
		if (res.code === 401) {
			num++
			if (num === 1) {
				ElMessage({
					message: '请登录',
					type: 'warning',
					offset: 68
				})
			}

			setTimeout(() => {
				// 重置登录状态并进入去登录页
				reset('401')
			}, 500)
		} else if (res.code === 4004) {
			// 路由跳转页面不存在 跳回到首页并且强制刷新当前系统
			return res
		} else if (res.code === 500) {
			return Promise.reject(res.msg || '网络错误，请重新加载')
		} else if (res.code === 5002) {
			return Promise.reject([res.msg || '', res.project || ''])
		}  else if (res.code == 501) {
			return res
		} else if (res.code == 503) {
			setTimeout(() => {
				router.replace('/')
			})
			
			// 延时调用清缓存接口（整个菜单大类）
			if (response.config && response.config.headers['filter-url']) {
				globalCacheDeleteNoPermissionApi(response.config.headers['filter-url'].replace('/', ''))
			}

			return Promise.reject(res.msg)
		} else if (res.code == 505) {
			return res
		} else if (res.code === 200) {
			// // 1. 特性检测：确保 API 存在
			// const connection = navigator.connection || {};
			// let connectionData = null

			// if (!connection) {
			// 	console.warn('当前浏览器不支持 navigator.connection API');
			// } else {
			// 	connectionData = {
			// 		type: connection.type,
			// 		effectiveType: connection.effectiveType,
			// 		rtt: (connection.rtt || '未知') + 'ms',
			// 		downlink: connection.downlink,
			// 		saveData: connection.saveData
			// 	}

			// 	// 2. 主动打印当前网络状态（页面加载时）
			// 	console.log(`[初始] 网络类型: ${connection.effectiveType || '未知'}, RTT: ${connection.rtt || '未知'}ms`);
			// }

			// const errorTip = {
			// 	error: JSON.stringify(error),
			// 	time: Date.now(),
			// 	api: configObj.url,
			// 	connectionData: connectionData ? JSON.stringify(connectionData) : '',
			// 	// 记录当前时间与请求开始时间的差值
			// 	elapsedTime: Date.now() - (error.config?.metadata?.startTime || 0)
			// }

			// console.log(errorTip, 'errorTip')

			return res
		}
		// }
		// if (status === 401) store.dispatch('FedLogOut').then(() => router.push({path: '/login'}));
	},
	error => {
		if (configObj.url !== '/message/getUnReadMessage' && configObj.url !== '/order/get' && configObj.url !==
			'/order/pay') {
			ElMessage({
				message: '网络错误，请重新加载' + configObj.url,
				type: 'info' // error => info 合并成一个提示样式
			})
		}

		// 1. 特性检测：确保 API 存在
		const connection = navigator.connection || {};
		let connectionData = null

		if (!connection) {
			console.warn('当前浏览器不支持 navigator.connection API');
		} else {
			connectionData = {
				type: connection.type,
				effectiveType: connection.effectiveType,
				rtt: (connection.rtt || '未知') + 'ms',
				downlink: connection.downlink,
				saveData: connection.saveData
			}
			// 2. 主动打印当前网络状态（页面加载时）
			console.log(`[初始] 网络类型: ${connection.effectiveType || '未知'}, RTT: ${connection.rtt || '未知'}ms`);
		}

		const errorTip = {
			error: JSON.stringify(error),
			time: Date.now(),
			api: configObj.url,
			connectionData: connectionData ? JSON.stringify(connectionData) : '',
			// 记录当前时间与请求开始时间的差值
			elapsedTime: Date.now() - (error.config?.metadata?.startTime || 0)
		}

		console.log(errorTip, 'errorTip')

		localStorage.setItem('errorLocalStorage', JSON.stringify(errorTip))

		console.log('err' + error) // for debug

		return Promise.reject(error)
	}
)

export default request